import moment from 'moment-timezone';
import { Act } from '../medyx-core/types/act';
import { ActivityStatus } from '../medyx-core/types/activity';

export const LOCAL_GUARD_EVENING_CODE = '42424';
export const LOCAL_GUARD_NIGHT_CODE = '42425';
export const SUPPORT_GUARD_CODE = '42426';

export const getIntensiveCareSupportStartTimeRange = (
  activityStartTime: number
): { startTime: number; endTime: number } => {
  const momentStartTime = moment(activityStartTime);
  let startHour = 7;
  let endHour = 24;

  if (momentStartTime.hours() < 7) {
    startHour = 0;
    endHour = 7;
  } else if (momentStartTime.hours() < 19) {
    startHour = 7;
    endHour = 19;
  } else {
    startHour = 19;
    endHour = 24;
  }

  return {
    startTime: moment(activityStartTime).hours(startHour).startOf('hour').valueOf(),
    endTime: moment(activityStartTime)
      .hours(endHour - 1)
      .endOf('hour')
      .valueOf()
  };
};

export const getIntensiveCareGuardStartTimeRange = (
  activityStartTime: number
): { startTime: number; endTime: number } => {
  let startTime = moment(activityStartTime).hours(19).startOf('hour').valueOf();
  let endTime = moment(activityStartTime).hours(23).endOf('hour').valueOf();

  if (moment(activityStartTime).hours() < 7) {
    startTime = moment(activityStartTime).subtract(1, 'day').hours(19).startOf('hour').valueOf();
    endTime = moment(activityStartTime).hours(7).endOf('hour').valueOf();
  }

  return {
    startTime,
    endTime
  };
};

export const isUserOnGuardDuty = (activityStartTime: number, actsInGuardPeriod: Act[]) => {
  if (moment(activityStartTime).hours() >= 7 && moment(activityStartTime).hours() < 19) {
    return false;
  }

  const guardCodesToConsider = [SUPPORT_GUARD_CODE];

  if (moment(activityStartTime).hours() < 7) {
    guardCodesToConsider.push(LOCAL_GUARD_NIGHT_CODE);
  } else {
    guardCodesToConsider.push(LOCAL_GUARD_EVENING_CODE);
  }

  return actsInGuardPeriod.some((act) => {
    if (act.status === ActivityStatus.CANCELED) return false;

    return act.codes.some(({ code }) => guardCodesToConsider.includes(code));
  });
};
